/* eslint-disable no-unused-vars */

import React, { useState, useRef } from "react";
import { useQuery, useMutation } from "react-query";
import { useParams } from "react-router-dom";
import DataTable from "../../Components/DataTable/DataTable";
import {
  I2cButton,
  I2cInput,
} from "@webcomponents/i2cwebcomponents/dist/react";
import ProgramTarget from "./ProgramTargetCellRenderer";
import ProgramType from "./ProgramTypeCellRenderer";
import FormsService from "../../Services/FormsAssignmentService";

const AssignProjects = ({ closeModal = () => null, onAssignSuccess }) => {
  const [page, setPage] = useState(1);
  const { id: userId } = useParams();
  const [reloadComponent, setReloadComponent] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: projects,
    isFetching,
    isLoading,
    refetch: refetchUsers,
  } = useQuery(
    ["assign-projects", userId],
    () => FormsService.getUserOtherForms(userId),
    {
      refetchOnWindowFocus: false,
    },
  );
  const table = useRef(null);
  // const { data: projectsData, total, per_page } = projects?.data?.data ?? {};
  // const projectsData = projects?.data.data.data ?? [];
  const columnDefs = [
    {
      field: "",
      headerName: " ",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      showDisabledCheckboxes: true,

      flex: 1,
      minWidth: 68,
       maxWidth: 80,
      suppressMenu: true,
    },
    {
      field: "form_name",
      headerName: "Client Name",
      sortable: true,
      flex: 2,
      minWidth: 200,
      suppressMenu: true,
    },
    {
      field: "form_type",
      headerName: "Program Type",
      cellRenderer: ProgramType,
      sortable: true,
      flex: 1,
      minWidth: 150,
        maxWidth: 178,
      suppressMenu: true,
    },
    {
      field: "created_at",
      headerName: "Target Date",
      cellRenderer: ProgramTarget,
      sortable: true,
      flex: 1,
      minWidth: 178,
        maxWidth: 178,
      suppressMenu: true,
    },
  ];

  // Define the delete session mutation hook
  const assignProject = useMutation({
    mutationFn: async (payload) => {
      return await FormsService.assignForms(userId, payload?.ids ?? []);
    },
    onSuccess: (data) => {
      setReloadComponent(true);
      onAssignSuccess({ success: true });
      closeModal();
    },
    onError: (e) => {
      console.log("api error", e);
      onAssignSuccess({ success: false, error: e });
      closeModal();
    },
  });
  // Function to handle session deletion
  const handleAssignProjects = async (selectedRows) => {
    const ids = selectedRows.map((row) => row.id);
    const payload = {
      userId,
      ids,
    };
    await assignProject.mutate(payload);
  };
  if (reloadComponent) {
    return (
      <AssignProjects
        closeModal={closeModal}
        onAssignSuccess={onAssignSuccess}
      />
    );
  }
  const noData = [
    {
      heading: "No records found",
      description: "No records were found.",
      type: "noData",
      icon: "outline-info-circle",
      iconColor: "var(--i2c-color-primary-600)",
    },
  ];

  const allForms = projects?.data?.forms ?? [];

  const filteredForms = searchQuery.trim()
    ? allForms.filter((f) =>
        f.form_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(f.form_type ?? "").toLowerCase().includes(searchQuery.toLowerCase())
      )
    : allForms;

  // if (isLoading || isFetching) return <OverlayLoader />;
  return (
    <React.Fragment>
      <div className="dTable">
        <div className="dTable-label">
          <span>Select Project(s)</span>
          <I2cInput
            placeholder="Search..."
            size="small"
            value={searchQuery}
            onI2cInput={(e) => setSearchQuery(e.target.value)}
            clearable
            style={{ minWidth: "200px" }}
          />
        </div>
        <DataTable
          columnDefs={columnDefs}
          rowData={filteredForms}
          title={""}
          noData={noData}
          pageSize={6}
          currentPage={page}
          setCurrentPage={setPage}
          total={projects?.data?.total ?? filteredForms.length}
          description={""}
          closeModal={closeModal}
          onAssign={handleAssignProjects}
          tableDataApi={table}
          rowSelection="multiple"
        />
      </div>
      <footer slot="footer">
        <I2cButton slot="footer" variant="secondary gray" onClick={closeModal}>
          Cancel
        </I2cButton>

        {allForms.length !== 0 && (
          <I2cButton
            slot="footer"
            variant="primary"
            disabled={assignProject.isLoading}
            loading={assignProject.isLoading}
            onClick={() => {
              const api = table.current.getGridApi();
              const selectedNodes = api.getSelectedNodes();
              const selectedRows = selectedNodes.map((node) => node.data);
              handleAssignProjects(selectedRows);
            }}
          >
            Assign
          </I2cButton>
        )}
      </footer>
    </React.Fragment>
  );
};

export default AssignProjects;
